import { render, staticRenderFns } from "./AmeriCommerceIcon.vue?vue&type=template&id=3b5021fe&scoped=true"
import script from "./AmeriCommerceIcon.vue?vue&type=script&lang=js"
export * from "./AmeriCommerceIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5021fe",
  null
  
)

export default component.exports